import { Button, InputField, Tooltip } from "components";
import { header } from "components/atoms/HeaderTableContainer";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  handleToggleBulkSearch,
  handleToggleExport,
} from "store/slices/ui.slice";
import constants from "utils/constants";
import { useTable } from "utils/hooks/useTable";
import { schema } from "./schema";
import { zodResolver } from "@hookform/resolvers/zod";

export const DatabaseHeader = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { count } = useAppSelector((state) => state.insights.leads);
  const { exportOpen, filterOpen, bulkSerch } = useAppSelector(
    (state) => state.ui
  );
  const { totalItemsSelecteds } = useTable({ totalItems: count });
  const { base, nav } = header({
    isExport: exportOpen,
    sidebarOpen: filterOpen,
  });

  const form = useForm({
    resolver: zodResolver(schema),
  });

  return (
    <div data-testid="pulse-header" className={base()}>
      <div className={nav()}>
        <FormProvider {...form}>
          <form
            className="flex flex-row gap-4"
            onSubmit={(e) => {
              e.preventDefault();
              // setSearchPeople(searchPeopleInput);
              // setIsAppliedFilter(true);
              // setPageCurrent(1);
              // fetchResults()
            }}
          >
            <Controller
              name="search"
              render={({ field }) => (
                <InputField
                  {...field}
                  placeholder="Search by keywords"
                  size="tiny"
                  // value={searchPeopleInput}
                  // onChange={(e: any) => setSearchPeopleInput(e.target.value)}
                  style={{ minWidth: "130px" }}
                />
              )}
            />
            <Button
              iconName="search"
              iconSize={16}
              size="xs"
              onClick={() => {
                // setSearchPeople(searchPeopleInput);
                // dispatch(setTriggerApplyFilters(true));
              }}
            >
              Search
            </Button>
          </form>
        </FormProvider>
        <div className="flex items-center text-sm gap-5">
          {totalItemsSelecteds > 0 && (
            <div
              className="flex items-center gap-5"
              data-testid="pulse-header-selected"
            >
              <p className="text-gray-400">
                <b className="text-white-500">
                  {totalItemsSelecteds > 0
                    ? Number(
                        count > constants.LIMIT_ENRICHMENT_ATTEMPT_PER_TASK
                          ? constants.LIMIT_ENRICHMENT_ATTEMPT_PER_TASK
                          : totalItemsSelecteds
                      )
                    : totalItemsSelecteds}
                </b>{" "}
                selected
              </p>
              <Tooltip content="Export selected leads to CSV">
                <Button
                  data-testid="export-button"
                  iconName="download"
                  size="xs"
                  className={`float-right ${
                    exportOpen
                      ? "bg-primary-700 text-white border border-solid border-primary-500"
                      : ""
                  }`}
                  onClick={() => dispatch(handleToggleExport())}
                >
                  Export
                </Button>
              </Tooltip>
            </div>
          )}
          <Button
            data-testid="button-bulk-export"
            onClick={() => dispatch(handleToggleBulkSearch())}
            className={`float-right ${
              bulkSerch
                ? "bg-primary-700 text-white border border-solid border-primary-500"
                : ""
            }`}
            iconName="search"
            size="xs"
          >
            Bulk Search
          </Button>
          <Button
            data-testid="button-export-list"
            onClick={() => navigate("/exports")}
            iconName="document"
            size="xs"
          >
            Export Lists
          </Button>
        </div>
      </div>
    </div>
  );
};
